import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "../../../elements/list/popup/styles";
import PopupView from "../../../elements/popupview";

const List = styled.div`
  margin-top: 1rem;
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  border: 1px solid #eee;
  border-radius: 6px;
  margin-bottom: 0.5rem;
`;

const Meta = styled.div`
  display: flex;
  flex-direction: column;
`;

const Badge = styled.span`
  font-size: 12px;
  color: ${({ active }) => (active ? "#2ecc71" : "#aaa")};
  font-weight: 600;
`;

const Actions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  min-height: 80vh;
`;

const LegalDocumentList = ({ data, onActivate, onDelete, t }) => {
  const [preview, setPreview] = useState(null);

  return (
    <>
      <List>
        {data.map((doc) => (
          <Item key={doc._id}>
            <Meta>
              <strong>{doc.file.originalName}</strong>
              <Badge active={doc.isActive}>
                v{doc.version} • {doc.isActive ? t("active") : t("inactive")}
              </Badge>
            </Meta>

            <Actions>
              <Button onClick={() => setPreview(doc)}>
                {t("View")}
              </Button>

              {!doc.isActive && (
                <Button onClick={() => onActivate(doc._id)}>
                  {t("Activate")}
                </Button>
              )}

              <Button danger onClick={() => onDelete(doc._id)}>
                {t("Delete")}
              </Button>
            </Actions>
          </Item>
        ))}
      </List>

      {/* PDF Preview Modal */}
      {preview && <PopupView
        // Popup data is a JSX element which is binding to the Popup Data Area like HOC
        popupData={<div style={{flex: 1}}><Iframe src={preview?.file?.url} title={preview?.file?.originalName} /></div>}
        closeModal={() => {
            setPreview(null)
        }}
        itemTitle={preview?.file?.originalName}
        ></PopupView>}
    </>
  );
};

export default LegalDocumentList;
